import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseFooterNetworks() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validateNetwork(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      icon: isEmpty(imgState),
    };

    setter(errorState);

    if (errorState.title || errorState.url || errorState.icon) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetFooterNetworks = (callback) => {
    MyAxios.get(`Admin_Mag_HomePage/GetFooterNetworks`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetFooterNetworks = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("icon", icon);
    }
    MyAxios.post(`Admin_Mag_HomePage/SetFooterNetworks`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const RemoveFooterNetworks = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_Mag_HomePage/RemoveFooterNetworks`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("لینک با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validateNetwork,
    GetFooterNetworks,
    SetFooterNetworks,
    RemoveFooterNetworks,
  };
}
